import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";
import PrayerRequestForm from "./PrayerRequestForm";

const PrayerRequestPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("prayerRequest");
  const [searchParams] = useSearchParams();
  const [language, setLanguage] = useState(); // Get the current language code (e.g., "en", "es")

  useEffect(() => {
    const language = searchParams.get("lang");
    if (language) {
      setLanguage(language);
    }
  }, [searchParams]);
  // This function is triggered on successful form submission
  const handleFormSuccess = () => {
    console.log("Form submitted successfully handleFormSuccess:");
    //setFormData(data); // Capture the data from the form
    navigate("/"); // Navigate after successful form submission
  };

  return (
    <>
      <div className="container-fluid position-relative p-0">
        <MenuBar />
      </div>

      <div className="container-fluid p-0">
        <div
          className="banner-image_sm"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/2.png)`,
          }}
        >
          <div className="banner-heading text-center wow fadeInDown">
            <h1 className="text-white">{t("title")}</h1>
          </div>
        </div>
      </div>

      <div className="container mt-3">
        <h4 className="text-center mb-2">
          <i>{t("quote")}</i> -{" "}
          {t("quoteReference")}
        </h4>
        <p>{t("description")}</p>

        {/* PrayerRequestForm Component with onSuccess handler */}
        <PrayerRequestForm onSuccess={handleFormSuccess} language={language} />
        {/* Divine Mercy and Rosa Mystica Text */}
        <div className="text-center mb-1 mt-1">
          <p className="text-muted">
            {t("DivineMercyText")}
            <br />
            {t("RosaMysticaText")}
          </p>
        </div>
      </div>

      <FooterPanel />
    </>
  );
};

export default PrayerRequestPage;
